import { useTransitionConfig } from './useTransitionConfig';
export function useTransitionTimeout(_a) {
    var timeout = _a.timeout;
    var config = useTransitionConfig();
    var enterTimeout;
    var exitTimeout;
    if (typeof timeout === 'number') {
        enterTimeout = timeout;
        exitTimeout = timeout;
    }
    else if (timeout && typeof timeout === 'object') {
        enterTimeout = timeout.enter;
        exitTimeout = timeout.exit;
    }
    return {
        enterTimeout: enterTimeout !== null && enterTimeout !== void 0 ? enterTimeout : config.enterTimeout,
        exitTimeout: exitTimeout !== null && exitTimeout !== void 0 ? exitTimeout : config.exitTimeout,
    };
}
